import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { moneyMask } from "utils/mask";
import { SecurityPageProps } from "models/security";
import ReactToPrint from "react-to-print";
import { useEffect, useRef, useState } from "react";
import PrintSummary from "../PrintSummary";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { addInvoiceInstallmentCalculation } from "redux/features/cliente/cliente-slice";
import { InvoiceInstallmentCalculationType } from "models/cliente";

interface IResponseCalculoFatura {
  detalhesParcelas: {
    parcelas: number;
    valor: number;
  }[];
  parcelas: number;
  taxaJuros: number;
  taxaServico: number;
  valorTaxaServico: number;
  valorTotal: number;
}

const CreditSummary = () => {
  const [data, setData] = useState<IResponseCalculoFatura>({
    detalhesParcelas: [],
    parcelas: 0,
    taxaJuros: 0,
    taxaServico: 0,
    valorTaxaServico: 0,
    valorTotal: 0,
  });
  const dispatch = useAppDispatch();
  const history = useHistory();

  const componentRef = useRef<HTMLDivElement>(null);

  const {
    cliente: { valuePaymentInvoice, valueAntecipationPurchase },
  } = useAppSelector((state) => state.cliente);

  const POSTCalculaParcelamentoFatura = useApi<IResponseCalculoFatura>(
    Endpoints.pagamentos.postCalculaParcelaFatura,
    ApiMethod.POST
  );

  useEffect(() => {
    if (Number(valuePaymentInvoice || valueAntecipationPurchase) > 0) {
      handlePopula();
    }
    // handlePopula usa useApi internamente/nao e memoizada; incluir causaria
    // refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuePaymentInvoice, valueAntecipationPurchase]);

  async function handlePopula() {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Calculando dados da tua fatura aguarde..."));
    sessionStorage.setItem("@TeuCard:LimiteExtrato", "30");
    const payload = {
      valorPrincipal: valuePaymentInvoice || valueAntecipationPurchase,
    };

    try {
      const response = await POSTCalculaParcelamentoFatura.callApi(payload);

      if (response.status >= 200 && response.status <= 300) {
        dispatch(setLoading(false));
        setData(response.data as IResponseCalculoFatura);
        dispatch(
          addInvoiceInstallmentCalculation(
            response?.data as InvoiceInstallmentCalculationType
          )
        );
      } else {
        dispatch(setLoading(false));
        const { mensagem } = response.data as any;
        showMessage("warning", "Atenção!", mensagem);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (error) {
      dispatch(setLoading(false));
      showMessage("warning", "Atenção!", "Tente novamente mais tarde!");
      history.push(RouteNames.ATENDIMENTO_FATURA);
    }
  }

  const clickBack = () => {
    if (valueAntecipationPurchase) {
      history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
    } else {
      history.push(RouteNames.ATENDIMENTO_FATURA);
    }
  };

  const clickPayments = () => {
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.FEEDBACK_FATURA_PINPAD,
      backStep: RouteNames.RESUMO_CREDITO_FATURA_PAGAMENTO,
      installmentPaymentInvoice: "1",
      title: "Pagar com cartão de crédito",
      description:
        "Tudo certo! Agora confirme no Pinpad o valor selecionado e aproxime ou insira o teu cartão de crédito.",
    };

    history.push({
      pathname: RouteNames.FEEDBACK_FATURA_PINPAD,
      state: { ...propsRouter },
    });
  };

  const clickCreditInstallment = () => {
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.PARCELAMENTO_CREDITO_FATURA_PAGAMENTO,
      backStep: RouteNames.RESUMO_CREDITO_FATURA_PAGAMENTO,
    };

    history.push({
      pathname: RouteNames.PARCELAMENTO_CREDITO_FATURA_PAGAMENTO,
      state: { ...propsRouter },
    });
  };

  return (
    <ContainerFlex>
      <St.TitleH1>Pagar com cartão de crédito</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>
            Confirme o valor de pagamento que será cobrado em teu cartão de
            crédito:
          </St.SpanDescription>
          <ContainerFlex row>
            <ContainerFlex padding={10}>
              <ContainerFlex>
                <ContainerFlex style={{ paddingLeft: "7rem" }}>
                  <St.SpanTitleInvoice>Valor informado:</St.SpanTitleInvoice>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(Number(valuePaymentInvoice || valueAntecipationPurchase))}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                  <St.SpanTitleInvoice>
                    {`Taxa de serviços de ${data?.taxaServico}%:`}
                  </St.SpanTitleInvoice>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(data?.valorTaxaServico)}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex padding={10}>
              <ContainerFlex>
                <ContainerFlex
                  style={{ paddingLeft: "7rem" }}
                  center
                  horizontal
                  align="flex-start"
                >
                  <St.SpanTitleInvoiceBold>
                    Valor pagamento
                  </St.SpanTitleInvoiceBold>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(data?.valorTotal)}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex padding={10}>
              <ContainerFlex center horizontal>
                <ContainerFlex style={{ paddingLeft: "7rem" }}>
                  <St.SpanTitleInvoice style={{ textAlign: "center" }}>
                    Este valor pode ser parcelado em{" "}
                    <St.SpanTitleInvoiceBold>{`até ${data?.parcelas}x`}</St.SpanTitleInvoiceBold>{" "}
                    no
                    {` teu cartão de crédito com juros de ${data?.taxaJuros}% a.m.`}
                  </St.SpanTitleInvoice>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex gap="8px" center horizontal row space>
        <AppButton
          content="Voltar"
          route={valueAntecipationPurchase ? RouteNames.ATENDIMENTO_ANTECIPACAO:RouteNames.ATENDIMENTO_FATURA}
          outlined={true}
          click={clickBack}
        />
        <button className="normal" onClick={() => clickPayments()}>
          {`Pagar ${moneyMask(data?.valorTotal)}`}
        </button>
        {Number(valuePaymentInvoice || valueAntecipationPurchase) >= 99 && (
          <button className="normal" onClick={() => clickCreditInstallment()}>
            Parcelar pagamento
          </button>
        )}
        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
      <div style={{ visibility: "hidden" }}>
        <div ref={componentRef}>
          <PrintSummary />
        </div>
      </div>
    </ContainerFlex>
  );
};

export default CreditSummary;
